import { AccordionV2, Input, Label } from "@web-app/components";
import { FieldValue, LocationDetails } from "@web-app/types";

type AddressField = {
  key: keyof Pick<
    LocationDetails,
    | "adminArea2"
    | "country"
    | "extendedAddress"
    | "locality"
    | "postalCode"
    | "state"
    | "streetAddress"
  >;
  label: string;
  placeholder: string;
  summaryLabel: string;
};

const addressFields: AddressField[] = [
  {
    key: "streetAddress",
    label: "Street Address",
    placeholder: "Enter street address",
    summaryLabel: "Street",
  },
  {
    key: "extendedAddress",
    label: "Apt / Suite",
    placeholder: "Enter apartment or suite",
    summaryLabel: "Apt / Suite",
  },
  {
    key: "locality",
    label: "City",
    placeholder: "Enter city",
    summaryLabel: "City",
  },
  {
    key: "state",
    label: "State",
    placeholder: "Enter state",
    summaryLabel: "State",
  },
  {
    key: "adminArea2",
    label: "County / District",
    placeholder: "Enter county or district",
    summaryLabel: "County / District",
  },
  {
    key: "postalCode",
    label: "Postal Code",
    placeholder: "Enter postal code",
    summaryLabel: "Postal Code",
  },
  {
    key: "country",
    label: "Country",
    placeholder: "Enter country",
    summaryLabel: "Country",
  },
];

interface AddressDetailsAccordionProps {
  addressType: "dropoff" | "pickup";
  debouncedHandleFieldChange: (property: string, value: FieldValue) => void;
  location?: LocationDetails;
}

export default function AddressDetailsAccordion({
  addressType,
  debouncedHandleFieldChange,
  location,
}: AddressDetailsAccordionProps) {
  const addressDetailsSummary = addressFields
    .map((field) => {
      const value = location?.[field.key];
      return value ? `${field.summaryLabel} - ${value}` : null;
    })
    .filter(Boolean)
    .join(", ");

  return (
    <AccordionV2
      className="rounded-t-none border-t-0 bg-white [&_button>div]:bg-gray-50"
      noHoverBg
      panelClassName="pt-3"
    >
      <AccordionV2.Label textAlign="left" labelClassName="pr-6">
        <span className="text-xs font-normal text-gray-700 break-words">
          {addressDetailsSummary || "No address details"}
        </span>
      </AccordionV2.Label>
      <AccordionV2.Content>
        <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
          {addressFields.map((field) => (
            <div key={field.key} className="flex flex-col gap-1">
              <Label>{field.label}</Label>
              <Input
                key={`${field.key}-${location?.[field.key] || ""}`}
                defaultValue={location?.[field.key] || ""}
                onChange={(value: string) =>
                  debouncedHandleFieldChange(
                    `${addressType}.${field.key}`,
                    value,
                  )
                }
                placeholder={field.placeholder}
              />
            </div>
          ))}
        </div>
      </AccordionV2.Content>
    </AccordionV2>
  );
}
